<template>
  <div class="buttons-wrapper">
    <div class="buttons">
      <ButtonFacebook />
      <ButtonTwitter />
      <ButtonLine />
    </div>
  </div>
</template>

<script>
import ButtonFacebook from '@/components/elements/ButtonFacebook.vue'
import ButtonTwitter from '@/components/elements/ButtonTwitter.vue'
import ButtonLine from '@/components/elements/ButtonLine.vue'
export default {
  components: {
    ButtonFacebook,
    ButtonTwitter,
    ButtonLine
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.buttons-wrapper {
  display: flex;
  align-items: center;
}
.buttons {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 20px;
  gap: 3px;
  @include mixins.media() {
    justify-content: flex-end;
  }
}
</style>
